module.exports = __webpack_public_path__ + "static/media/HK-HKSYU.10d7fb32.jpg";